import React from "react";
import { Tooltip } from "@mui/material";

import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";

import { LastUpdatedDetails } from "./helper";

const UserLogs = ({ rows, isLoading, rowCount, currentPage, onPageChange }) => {
  const columns = [
    new AGridColDef("operation", "Events")
      .setMinWidth(125)
      .renderCellComponent((params) =>
        params?.value ? <span>{params.value}</span> : <div>-</div>
      ),

    new AGridColDef("eventMessage", "Value")
      .setMinWidth(205)
      .renderCellComponent((params) =>
        params?.value ? (
          params.value.length > 33 ? (
            <Tooltip title={params.value}>
              <span>{params.value.substr(0, 32)}...</span>
            </Tooltip>
          ) : (
            params.value
          )
        ) : (
          <div>-</div>
        )
      ),

    new AGridColDef("updatedOn", "Updated on")
      .setMinWidth(200)
      .columnAlign("center")
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip
            title={LastUpdatedDetails(params?.value, params?.row.updatedBy)}
          >
            <div className={`mx-auto ellipsis-text-container`}>
              {LastUpdatedDetails(params?.value, params?.row.updatedBy)}
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
      ),

    // new AGridColDef("status", "Status")
    //   .setMinWidth(205)
    //   .columnAlign("right")
    //   .renderCellComponent((params) => {
    //     return (
    //       <div>
    //         {params.value.toLowercase() === "failed" && (
    //           <span className="text-primary cursor-pointer text-sm text-bold">
    //             <RefreshIcon color="#00B0F5" width="11" height="9" />
    //             Retry
    //           </span>
    //         )}
    //         <AChip
    //           label={capitalize(params?.value)}
    //           success={params.value === "SUCCESS"}
    //         />
    //       </div>
    //     );
    //   }),
  ];

  return (
    <div className="mt--4" style={{ height: "500px" }}>
      <ADataGrid
        rows={rows}
        columns={columns}
        rowId={(row) => row.id}
        loading={isLoading}
        rowCount={rowCount}
        nextButtonHandler={(page) => {
          onPageChange(page);
        }}
        currentPage={currentPage}
        pinLastColumn
        height="100%"
      />
    </div>
  );
};

export default UserLogs;
